import { ModulesConfigMap, ModulesMap } from '../data/modulesMaps'

export default {
  getFuelStationRawEvents: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATION_RAW_EVENTS].GET_FUEL_STATION_RAW_EVENTS,
  },
  getFuelStationRawEvent: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATION_RAW_EVENTS].GET_FUEL_STATION_RAW_EVENT,
  },
  getFuelStationRawEventPreview: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.FUEL_STATION_RAW_EVENTS].GET_FUEL_STATION_RAW_EVENT_PREVIEW,
  },
}